var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.1875C5.49224 2.1875 4.26562 3.41414 4.26562 4.92188C4.26562 6.42961 5.49224 7.65625 7 7.65625C8.50776 7.65625 9.73438 6.42961 9.73438 4.92188C9.73438 3.41414 8.50776 2.1875 7 2.1875ZM7 6.5625C6.09536 6.5625 5.35938 5.82652 5.35938 4.92188C5.35938 4.01723 6.09536 3.28125 7 3.28125C7.90464 3.28125 8.64062 4.01723 8.64062 4.92188C8.64062 5.82652 7.90464 6.5625 7 6.5625Z",
    fill: "#C7D2D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8198 4.63266C13.2835 3.77199 10.5544 0 7 0C3.44641 0 0.71657 3.77193 0.180223 4.63266L0 4.92188L0.180223 5.21109C0.716516 6.07176 3.44561 9.84375 7 9.84375C10.5536 9.84375 13.2834 6.07182 13.8198 5.21109L14 4.92188L13.8198 4.63266ZM7 8.75C4.24277 8.75 1.97252 5.85829 1.30955 4.92144C1.97129 3.98382 4.23571 1.09375 7 1.09375C9.75704 1.09375 12.0272 3.98505 12.6905 4.92231C12.0287 5.85996 9.76429 8.75 7 8.75Z",
    fill: "#C7D2D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.16cf3b72b585974f61d970dda48b8b41.svg";
export { ForwardRef as ReactComponent };